import { render, staticRenderFns } from "./wrappComments.vue?vue&type=template&id=4f5017ee&scoped=true&"
import script from "./wrappComments.vue?vue&type=script&lang=js&"
export * from "./wrappComments.vue?vue&type=script&lang=js&"
import style0 from "./wrappComments.vue?vue&type=style&index=0&id=4f5017ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5017ee",
  null
  
)

export default component.exports